export const DocketEntryEditInviteState = {
  isInviteVisible: false,
}

export const DocketEntryEditInviteActions = {}

export const DocketEntryEditInviteGetters = {
  isDocketEntryEditorInviteVisible: state => state.docketEntryEdit.isInviteVisible,
}

export const DocketEntryEditInviteMutations = {
  setDocketEntryEditorInviteVisibility: (state, visible) => {
    state.docketEntryEdit.isInviteVisible = visible
  },
}
